import { PageLoader } from '@/components/Elements/PageLoader/PageLoader';
import { SignUp } from '@/components/Views/SignUp/SignUp/SignUp';
import { useSearchParams, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { DirectInvite } from '@/components/Views/SignUp/DirectInvite/DirectInvite';
import { IndirectInvite } from '@/components/Views/SignUp/IndirectInvite/IndirectInvite';
import { useMounted } from '@/hooks/useMounted';
import { useTranslation } from 'react-i18next';
import { useAuthBranding } from '@/components/Providers/BrandingProvider/BrandingProvider';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

enum SignUpTypes {
  REGULAR = 'REGULAR',
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT',
}

export default function SignUpPage() {
  const { t } = useTranslation();
  const mounted = useMounted();
  const params = useParams();
  const locale = params.lang || 'en';
  const { branding } = useAuthBranding();
  useDocumentTitle(branding ? t('signUp.title') : t('signUp.pageTitle'));

  const [searchParams] = useSearchParams();

  const signUpType = useMemo(() => {
    if (Boolean(searchParams.get('direct-inv'))) {
      return SignUpTypes.DIRECT;
    }

    if (Boolean(searchParams.get('indirect-inv'))) {
      return SignUpTypes.INDIRECT;
    }

    return SignUpTypes.REGULAR;
  }, [searchParams]);

  const renderView = () => {
    switch (signUpType) {
      case SignUpTypes.DIRECT:
        return <DirectInvite />;
      case SignUpTypes.INDIRECT:
        return <IndirectInvite />;
      case SignUpTypes.REGULAR:
        return <SignUp locale={locale} />;
    }
  };

  return (
    <section>
      {!mounted ? <PageLoader /> : renderView()}
    </section>
  );
}
